export const state = {
  current: null,
  currentMembers: [],
  currentProjectMembers: [],
  currentInvites: [],
  pendingInvites: [],
  orgs: [],
  selectedOrg: localStorage.getItem('selectedOrgId') || null, // org id,
  apikeys: []
}
